import { type UIEvent } from 'react'
import { observer } from 'mobx-react-lite'
import {
  DropdownGroup,
  DropdownTextInput,
  type IDropdownItem,
  Scrollbar,
  SpinnerLoader,
} from 'shared/ui'
import styles from './styles.module.scss'

type ILinkDropdownCustomComponentProps = {
  search: string
  setSearch: (value: string) => void
  itemsList: IDropdownItem[]
  setItem: (item: IDropdownItem) => void
  onClose: () => void
  removeError: () => void
  hasMore?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
}

export const LinkDropdownCustomComponent = observer(
  ({
    search,
    setSearch,
    itemsList,
    setItem,
    onClose,
    removeError,
    hasMore,
    isLoadingMore,
    onLoadMore,
  }: ILinkDropdownCustomComponentProps) => {
    const handleScroll = (e: UIEvent) => {
      if (!onLoadMore || !hasMore || isLoadingMore) return
      const target = e.target as HTMLDivElement
      if (target.scrollHeight <= target.scrollTop + target.offsetHeight + 100) {
        onLoadMore()
      }
    }

    return (
      <>
        <DropdownTextInput
          textFieldProps={{
            value: search,
            onChange: setSearch,
            InputProps: {
              placeholder: 'Search',
            },
          }}
          ariaLabel='searchLinks'
        />
        <Scrollbar autoHeight autoHeightMax={134} onScroll={handleScroll}>
          {itemsList.length ? (
            <DropdownGroup
              items={itemsList}
              onChange={(item) => {
                setItem?.(item)
                removeError()
                onClose()
              }}
              stylesWrap={{
                padding: '4px',
              }}
              isScroll={false}
            />
          ) : (
            !isLoadingMore && <div className={styles.noResult}>No results found</div>
          )}
          {isLoadingMore && (
            <div className={styles.dropdownLoader}>
              <SpinnerLoader ariaLabel='LinkDropdownCustomComponent' />
            </div>
          )}
        </Scrollbar>
      </>
    )
  }
)
